import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import WaitingList from './vue/waitingList.vue'

const waitingListApp = "#waitingListApp";
if (document.querySelectorAll(waitingListApp).length) {
    const seedData = {};

    const waitingList = createApp({
        data() { return seedData },
        render: () => h(WaitingList)
    }, seedData);

    waitingList.use(PrimeVue);
    waitingList.use(ToastService);
    waitingList.mount(waitingListApp);

}
